import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const FreelancerIcon: React.FC<IconProps> = ({ size, style, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={size ?? '24'}
    height={size ?? '24'}
    viewBox="-0.23 0 97.266 72.333"
    data-testid="freelancer-icon"
  >
    <path
      fill={color ?? '#29b2fe'}
      d="m56.897 0 6.624 9.29L97.036 0M22.075 72.333l18.13-17.725-10.912-11.71M54.152 0l-9.69 8.738 16.298.608M16.482 0l3.48 7.133 19.18 1.195M26.75 36.986l14.17-26.434L-.23 8.328M28.4 38.662 41.785 53.04 56.55 38.567l4.582-26.957-17.993-.918"
    />
  </svg>
);
export default FreelancerIcon;
